import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight, Phone, MessageCircle } from 'lucide-react';
import { BreadcrumbSchema } from '../components/SchemaMarkup';
import { businessData } from '../data/seoData';

const StandortePage = () => {
  const handleWhatsApp = () => window.open(`https://wa.me/${businessData.whatsapp}`, '_blank');
  const handleCall = () => window.location.href = `tel:${businessData.phone}`;

  const allCities = [
    { name: 'Frankfurt am Main', url: '/kfz-gutachter-frankfurt', description: 'Schnell vor Ort in der Finanzmetropole' },
    { name: 'Wiesbaden', url: '/kfz-gutachter-wiesbaden', description: 'Landeshauptstadt Hessen' },
    { name: 'Mainz', url: '/kfz-gutachter-mainz', description: 'Rheinland-Pfalz Landeshauptstadt' },
    { name: 'Darmstadt', url: '#', description: 'Wissenschaftsstadt' },
    { name: 'Offenbach am Main', url: '#', description: 'Direkt neben Frankfurt' },
    { name: 'Hanau', url: '#', description: 'Main-Kinzig-Kreis' },
    { name: 'Rüsselsheim', url: '#', description: 'Automobilstadt' },
    { name: 'Bad Homburg', url: '#', description: 'Hochtaunuskreis' },
    { name: 'Neu-Isenburg', url: '#', description: 'Zwischen Frankfurt & Offenbach' },
    { name: 'Hofheim', url: '#', description: 'Main-Taunus-Kreis' }
  ];

  return (
    <div style={{ background: '#FFFFFF', position: 'relative' }}>
      <Helmet>
        <title>Standorte & Einsatzgebiet | Crash Check Kfz Gutachter Rhein-Main</title>
        <meta name="description" content="Kfz Gutachter im gesamten Rhein-Main-Gebiet. Schnell vor Ort in Frankfurt, Wiesbaden, Mainz, Darmstadt und weiteren Städten." />
        <link rel="canonical" href={`${businessData.url}/standorte`} />
      </Helmet>

      <BreadcrumbSchema items={[{ name: 'Start', url: '/' }, { name: 'Standorte', url: '/standorte' }]} />

      <section style={{ paddingTop: '140px', paddingBottom: '80px', background: 'linear-gradient(180deg, #F0F4F8 0%, #FFFFFF 100%)' }}>
        <div className="container mx-auto px-4" style={{ maxWidth: '1200px' }}>
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h1 style={{ fontSize: 'clamp(36px, 6vw, 56px)', fontWeight: '700', lineHeight: '1.2', color: '#1a202c', marginBottom: '24px' }}>
              Einsatzgebiet Rhein-Main
            </h1>
            <p style={{ fontSize: '20px', lineHeight: '1.7', color: '#4a5568', marginBottom: '40px' }}>
              Wir sind im gesamten Rhein-Main-Gebiet schnell vor Ort. Von Frankfurt über Wiesbaden bis Mainz und darüber hinaus.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={handleWhatsApp} className="btn-primary" style={{ minHeight: '56px' }}>
                <MessageCircle size={20} />WhatsApp Soforthilfe
              </button>
              <button onClick={handleCall} className="btn-secondary" style={{ minHeight: '56px' }}>
                <Phone size={20} />Jetzt anrufen
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="pad-large" style={{ background: '#FFFFFF' }}>
        <div className="container mx-auto px-4" style={{ maxWidth: '1200px' }}>
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 40px)', fontWeight: '700', color: '#1a202c', marginBottom: '60px', textAlign: 'center' }}>
            Unsere Standorte
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {allCities.map((city, index) => (
              city.url === '#' ? (
                <div
                  key={index}
                  className="glass-card"
                  style={{
                    padding: '32px',
                    opacity: 0.6,
                    cursor: 'not-allowed'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                    <MapPin size={24} style={{ color: '#0891B2' }} />
                    <h3 style={{ fontSize: '20px', fontWeight: '700', color: '#1a202c' }}>
                      {city.name}
                    </h3>
                  </div>
                  <p style={{ fontSize: '15px', color: '#718096', marginBottom: '16px' }}>
                    {city.description}
                  </p>
                  <span style={{ fontSize: '13px', color: '#9CA3AF', fontStyle: 'italic' }}>
                    Detailseite in Kürze verfügbar
                  </span>
                </div>
              ) : (
                <Link
                  key={index}
                  to={city.url}
                  className="glass-card"
                  style={{
                    padding: '32px',
                    textDecoration: 'none',
                    display: 'block',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                    <MapPin size={24} style={{ color: '#0891B2' }} />
                    <h3 style={{ fontSize: '20px', fontWeight: '700', color: '#1a202c' }}>
                      {city.name}
                    </h3>
                  </div>
                  <p style={{ fontSize: '15px', color: '#4a5568', marginBottom: '16px' }}>
                    {city.description}
                  </p>
                  <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#0891B2', fontSize: '15px', fontWeight: '600' }}>
                    Mehr erfahren
                    <ArrowRight size={16} />
                  </div>
                </Link>
              )
            ))}
          </div>
        </div>
      </section>

      <section className="pad-large" style={{ background: '#F0F4F8' }}>
        <div className="container mx-auto px-4" style={{ maxWidth: '900px' }}>
          <div style={{ background: 'linear-gradient(135deg, rgba(8, 145, 178, 0.1) 0%, rgba(6, 182, 212, 0.05) 100%)', border: '1px solid rgba(8, 145, 178, 0.2)', borderRadius: '24px', padding: '60px 40px', textAlign: 'center' }}>
            <h2 style={{ fontSize: 'clamp(28px, 4vw, 40px)', fontWeight: '700', color: '#1a202c', marginBottom: '20px' }}>
              Nicht Ihre Stadt dabei?
            </h2>
            <p style={{ fontSize: '18px', color: '#4a5568', lineHeight: '1.7', marginBottom: '40px', maxWidth: '600px', margin: '0 auto 40px' }}>
              Wir sind auch in weiteren Städten und Gemeinden im Rhein-Main-Gebiet im Einsatz. Einfach anfragen!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={handleWhatsApp} className="btn-primary" style={{ minHeight: '56px' }}>
                <MessageCircle size={20} />WhatsApp
              </button>
              <Link to="/kontakt" className="btn-secondary" style={{ minHeight: '56px', display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
                Kontakt aufnehmen
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StandortePage;
